'use client';

import { Amplify } from 'aws-amplify';
import { awsConfig } from '@atalan/auth/amplify';
Amplify.configure(awsConfig, {
  ssr: true
});
export default function ConfigureAmplifyClientSide() {
  return null;
}